function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStaticCode, createDynamicCode } from '@/api/alliance';
export default {
  name: 'AllianceMerchantCode',
  data: function data() {
    return {
      storeId: 0,
      staticCode: '',
      staticLoading: false,
      dynamicLoading: false,
      dynamicCode: null,
      countdown: 0,
      ttl: 60,
      dynamicForm: {
        bizNo: '',
        amountYuan: undefined,
        storeId: 0
      },
      dynamicRules: {
        bizNo: [{
          required: true,
          message: '请填写订单号',
          trigger: 'blur'
        }],
        amountYuan: [{
          required: true,
          message: '请填写订单金额',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    clearTimer: function clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    loadStaticCode: function () {
      var _loadStaticCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.staticLoading = true;
              _context.p = 1;
              _context.n = 2;
              return getStaticCode(this.storeId || 0);
            case 2:
              res = _context.v;
              this.staticCode = typeof res === 'string' ? res : res && res.codeToken || '';
              this.renderQr('staticQr', this.staticCode);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              _context.p = 4;
              this.staticLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function loadStaticCode() {
        return _loadStaticCode.apply(this, arguments);
      }
      return loadStaticCode;
    }(),
    submitDynamic: function submitDynamic() {
      var _this = this;
      this.$refs.dynamicForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var amount, res, _t2;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                _this.dynamicLoading = true;
                _context2.p = 2;
                // 后端金额单位是分，页面按元填
                amount = Math.round(_this.dynamicForm.amountYuan * 100);
                _context2.n = 3;
                return createDynamicCode(_this.dynamicForm.bizNo, amount, _this.dynamicForm.storeId || 0);
              case 3:
                res = _context2.v;
                _this.dynamicCode = res || null;
                _this.renderQr('dynamicQr', res && res.codeToken);
                _this.startCountdown(res);
                _context2.n = 5;
                break;
              case 4:
                _context2.p = 4;
                _t2 = _context2.v;
              case 5:
                _context2.p = 5;
                _this.dynamicLoading = false;
                return _context2.f(5);
              case 6:
                return _context2.a(2);
            }
          }, _callee2, null, [[2, 4, 5, 6]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    /**
     * 倒计时以服务端返回的 expireTime 为准。
     * 按固定 60 秒本地倒数的话，客户端时钟慢一点就会出现「页面还显示 3 秒、
     * 用户扫了却提示已过期」，收银台最不需要的就是这种争执。
     */
    startCountdown: function startCountdown(code) {
      var _this2 = this;
      this.clearTimer();
      var expireAt = code && code.expireTime ? new Date(code.expireTime).getTime() : Date.now() + this.ttl * 1000;
      var tick = function tick() {
        _this2.countdown = Math.max(0, Math.ceil((expireAt - Date.now()) / 1000));
        if (_this2.countdown <= 0) _this2.clearTimer();
      };
      tick();
      this.timer = setInterval(tick, 1000);
    },
    renderQr: function renderQr(refName, text) {
      var _this3 = this;
      if (!text) return;
      this.$nextTick(function () {
        var box = _this3.$refs[refName];
        if (!box) return;
        box.innerHTML = '';
        // 项目已依赖 qrcodejs2，按需加载避免进首屏包
        import('qrcodejs2').then(function (_ref2) {
          var QRCode = _ref2.default;
          new QRCode(box, {
            text: text,
            width: 180,
            height: 180
          });
        });
      });
    },
    copy: function copy(text) {
      var input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('已复制');
    }
  }
};